import { memo } from "react"
import { Box, Typography } from "@mui/material"
import PropTypes from "prop-types"
import { isFunction, isNil, isEmpty } from "lodash"
import { getFormatter } from "helpers/metrics/formatters"
import ClickableMetricCell from "./clickable-metric-cell"

const MetricCell = memo(({ params, metric }) => {
  const rawValue = params.value
  const item = params.row.contributor
  const isAggregation = params.row.isAggregation || false

  const { format, formatter, getAction, action, enhanceValue } = metric

  const renderFormatter = (() => {
    const customFormatter = format && getFormatter(format, { includeUnits: false, handleNull: true })
    return customFormatter || formatter
  })()

  const formattedValue = (() => {
    if (isNil(rawValue)) return "-"

    if (isFunction(renderFormatter)) {
      return renderFormatter(rawValue)
    }

    return rawValue
  })()

  const enhancedValue = (() => {
    if (isFunction(enhanceValue)) {
      return enhanceValue(item, formattedValue, metric, isAggregation)
    }

    return formattedValue
  })()

  const metricAction = isFunction(getAction) ? getAction(item) : action
  const shouldBeClickable = metricAction && !isNil(formattedValue) && isEmpty(item.children) && !item.isUnmodeled

  if (shouldBeClickable) {
    return (
      <ClickableMetricCell
        enhancedValue={enhancedValue}
        metricAction={metricAction}
        item={item}
        metric={metric}
      />
    )
  }

  return (
    <Box className="metric-cell">
      <Typography variant="body2" component="div" noWrap>
        {enhancedValue}
      </Typography>
    </Box>
  )
})

MetricCell.displayName = "MetricCell"

MetricCell.propTypes = {
  params: PropTypes.shape({
    value: PropTypes.any,
    row: PropTypes.shape({
      contributor: PropTypes.object.isRequired,
      isAggregation: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  metric: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    format: PropTypes.string,
    formatter: PropTypes.func,
    dataGetter: PropTypes.func,
    dataPath: PropTypes.string,
    getAction: PropTypes.func,
    action: PropTypes.func,
    enhanceValue: PropTypes.func,
  }).isRequired,
}

export default MetricCell
